import type { MainPageConfig } from '@/app/(football)/[team]/main/_context/types';

export const steelersConfig: MainPageConfig = {
  notificationRoutes: {
    welcome: '/point-lounge/earn',
    attendance: '/point-lounge/earn',
    minigame: '/mini-game',
    lounge: '/point-lounge/use',
  },
};
